import consumer from "./consumer";

let testChannel = null;

function connectToTestChannel(roomId, callback_fn) {
  if (testChannel) return;

  testChannel = consumer.subscriptions.create(
    { channel: "TestChannel", room_id: roomId.toString()},
    {
      connected() {
        console.log(`✅ Connected to TestChannel room ${roomId}`);
      },

      disconnected() {
        console.log("❌ Disconnected from TestChannel");
      },

      received(data) {
        console.log("📩 Received:", data);
        if (typeof callback_fn === 'function') {
          callback_fn(data);
        }
        // const container = document.getElementById("messages");
        // if (container) {
        //   const p = document.createElement("p");
        //   p.textContent = data.message;
        //   container.appendChild(p);
        // }
      },

      speak(message) {
        this.perform("speak", { message: message, room_id: roomId });
      }
    }
  );

  window.testChannel = testChannel; // Optional: for console access
}

function disconnectFromTestChannel() {
  if (testChannel) {
    consumer.subscriptions.remove(testChannel);
    testChannel = null;
    window.testChannel = testChannel
    console.log("🔌 Manually disconnected from TestChannel");
  }
}

window.connectToTestChannel = connectToTestChannel;
window.disconnectFromTestChannel = disconnectFromTestChannel;




